module.exports = __webpack_public_path__ + "gm992021/img/jianghu-9.png?b923ffca";